import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ProfileShape, UserShape, SubscriptionShape } from '../shapes';
import DateMaster from '../stores/utils/date_master';
import PropTypes from 'prop-types';
import Waiting from './waiting';
import TackLikeButton from './tack_like_button';
import verified from '../images/verified-white.svg';

export default class Profile extends React.Component {
  static propTypes = {
    user: UserShape,
    profile: ProfileShape,
    subscription: SubscriptionShape,
    params: PropTypes.object,
    onLoadProfile: PropTypes.func,
    onFollow: PropTypes.func,
    onUnFollow: PropTypes.func,
    onReset: PropTypes.func,
    onLikeTack: PropTypes.func,
    onUnLikeTack: PropTypes.func
  }

  componentDidMount() {
    if (this.props.profile && this.props.profile.get('slug') !== this.props.params.slug) {
      this.props.onReset();
      this.props.onLoadProfile(this.props.params.slug);      
    }
  }

  render() {
    if (this.props.profile.get('error')) {
      return this.renderNotPublic();
    } else if (this.props.profile.get('loading')) {
      return this.renderLoading();
    } else {
      return this.renderProfile();
    }
  }

  renderProfile() {
    const name = this.props.profile.get('name') || this.props.profile.get('slug');
    return (
      <Fragment>
        <Helmet>
          <title>{ name }</title>
          <meta name="og:title" content={ name }></meta>
          <meta name="description" content={ this.props.profile.get('headline') }></meta>
          <meta name="og:description" content={ this.props.profile.get('headline') }></meta>
          <meta name="og:url" content={ window.location.href }></meta>  
        </Helmet>           
        <div className='profile row'>
          <div className='col-sm-5 profile-header'>
            { this.renderHeader() }
          </div>
          <div className='col-sm-7'>
            { this.renderActiveTacks() }
            { this.renderFinishedTacks() }
          </div>
        </div>
      </Fragment>
    )
  }

  renderHeader() {
    const name = this.props.profile.get('name') || this.props.profile.get('slug');
    const tacksCount = this.props.profile.get('activeTacks').size + this.props.profile.get('finishedTacks').size;
    return (
      <div className='sidebar'>
        <h1>{ name }</h1>
        {this.renderUnlimited()}
        <p>{ this.props.profile.get('headline') }</p>
        <ul className='item-meta'>
          <li><b>Since</b>: { DateMaster.format(this.props.profile.get('createdAt')) }</li>
          <li><b>Tacks</b>: { tacksCount }</li>
          <li><b>Points</b>: { this.props.profile.get('points') }</li>
          <li>
            <Link to={`/people/${this.props.profile.get('slug')}/follows`} className='follow-link'>
              <b>Following</b>: { this.props.profile.get('followsCount') }
            </Link>
          </li>
          <li>
            <Link to={`/people/${this.props.profile.get('slug')}/followers`} className='follow-link'>
              <b>Followers</b>: { this.props.profile.get('followersCount') }
            </Link>
          </li>
        </ul>
        { this.renderEdit() }
        { this.renderFollowAction() }
      </div>
    );
  }

  renderUnlimited() {
    if (this.props.profile.get('hasActiveSubscription')) {
      // If the visitor is looking at a public profile, or they're logged in
      // and already have an active subscription, no need to try to upgrade them.
      if (!this.props.user || this.props.subscription.get('active')) {
        return (
          <div className='verfified-mark-20 give-me-15-down'>
            <img src={verified} alt='Verified and Unlimited' /> <b>Unlimited</b>
          </div>
        );
      } else {
        return (
          <Link to='/subscription'>
            <div className='verfified-mark-20 give-me-15-down'>
              <img src={verified} alt='Verified and Unlimited' /> <b>Unlimited</b>
            </div>
          </Link>
        );
      }
    } else {
      return null;
    }
  }

  renderEdit() {
    if (this.lookingAtOwnProfile()) {
      return (
        <ul className='item-meta'>
          <li>
            <Link to='/account/profile/edit'>Edit or Turn Off Profile</Link>
          </li>
        </ul>
      );
    } else {
      return null;
    }
  }

  renderFollowAction() {
    if (!this.props.user.get('loggedIn') || this.lookingAtOwnProfile()) {
      return null;
    } else if (this.props.profile.get('followedAt')) {
      return (
        <Fragment>
          <button className='btn btn-light follow' data-primary-cta onClick={ (e) => this.onUnFollow(e) }>Unfollow</button>
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          <button className='btn btn-light follow' data-primary-cta onClick={ (e) => this.onFollow(e) }>Follow</button>
        </Fragment>
      );
    }
  }

  renderFinishedTacks() {
    if (this.props.profile.get('finishedTacks').size > 0) {
      const finishedTacks = this.props.profile.get('finishedTacks').map((finishedTack, i) => {
        return (
          <li key={ i }>
            <div className='user-tack'>
              <Link to={ `/words/${ finishedTack.get('wordText') }/${ finishedTack.get('language') }` }>
                <h4 className='word-title'>{ finishedTack.get('wordText') }</h4>
              </Link>
              <ul className='item-meta'>
                <li>
                  <b>Finished</b>: { DateMaster.format(finishedTack.get('lastSentDate')) }
                </li>
                <li>
                  <TackLikeButton tackId={ finishedTack.get('slug') } user={ this.props.user } likedBy={ finishedTack.get('likedBy') } onLikeTack={ this.props.onLikeTack } onUnLikeTack={ this.props.onUnLikeTack } />
                </li>
              </ul>
            </div>
          </li>
        );
      });

      return (
        <div className='user-tacks'>
          <h3>Tacked</h3>
          <ol>{ finishedTacks }</ol>
        </div>
      );
    } else {
      return null;
    }
  }

  renderActiveTacks() {
    if (this.props.profile.get('activeTacks').size > 0) {
      const activeTacks = this.props.profile.get('activeTacks').map((activeTack, i) => {
        return (
          <li key={ i }>
            <div className='user-tack'>
              <Link to={ `/words/${ activeTack.get('wordText') }/${ activeTack.get('language') }` }>
                <h4 className='word-title'>{ activeTack.get('wordText') }</h4>
              </Link>
              <ul className='item-meta'>
                <li>
                  <b>Started</b>: { DateMaster.format(activeTack.get('createdAt')) }
                </li>
                <li>
                  <TackLikeButton tackId={ activeTack.get('slug') } user={ this.props.user } likedBy={ activeTack.get('likedBy') } onLikeTack={ this.props.onLikeTack } onUnLikeTack={ this.props.onUnLikeTack } />
                </li>
              </ul>
            </div>
          </li>
        );
      });

      return (
        <div className='user-tacks'>
          <h3>Tacking</h3>
          <ol>{ activeTacks }</ol>
        </div>
      );
    } else {
      return null;
    }
  }

  renderNotPublic() {
    return (
      <div className='error'>
        <h2>Hmm. This profile is not public.</h2>
      </div>
    );
  }

  renderLoading() {
    return(
      <Waiting waitingText={ 'Crunching' } />
    );
  }

  onFollow(e) {
    e.preventDefault();
    this.props.onFollow(this.props.profile.get('slug'));
  }

  onUnFollow(e) {
    e.preventDefault();
    this.props.onUnFollow(this.props.profile.get('slug'));
  }

  lookingAtOwnProfile() {
    return this.props.user.get('loggedIn') && (this.props.user.get('slug') === this.props.profile.get('slug'))
  }
}



// WEBPACK FOOTER //
// ./src/components/profile.jsx